import { RowsView } from "common/views/rows/Rows.view";
import { Fragment, IDataFragment } from "core/components/FragmentProvider";
import Article from "panels/knowledgebase/entities/Article";
import { IArticleParams } from "../../entities/ArticleParams";
import KnowledgeBase from "panels/knowledgebase/entities/KnowledgeBase";

export interface IParentContainerFragmentProps {
	children?: JSX.Element[];
	article: Article[];
	knowledgeBase: KnowledgeBase;
	params: IArticleParams;
	renderItem: (article: Article, index?: number) => JSX.Element;
	renderExpand?: (article: Article) => JSX.Element;
	articleFragments: Array<IDataFragment<any>>;
}

export const rows: Fragment<IParentContainerFragmentProps> = {
	name: "Rows",
	component: ({ article, renderItem }) => (
		<RowsView
			items={article}
			renderItem={renderItem}
			viewKey="articleList.container.rows"
		/>
	)
};



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/fragments/container/parentContainerFragments.tsx